<mat-form-field
  [rsClearFormFieldButtonCallback]="clearValue.bind(this)"
  data-testid="rs-dynamic-mat-autocomplete"
  rsAddClearFormFieldButton
>
  <mat-label>{{ placeholder | translate }}</mat-label>
  <input
    (blur)='onBlurHandler()'
    (focus)='onFocus()'
    [formControl]="filterFormControl"
    [matAutocomplete]='rsDynamicMatAutocompleteComponent'
    [required]="required"
    [rs-mat-autocomplete-enforce-selection]="{ actionOnWhenNotSelected: required ? 'error' : 'reset', optionSelected: autocompleteFormControl.control?.value }"
    data-testid="input-filter-options"
    matInput
    type="text"
  >
  <div
    class='me-8px'
    matPrefix
  >
    @if (!isSearchingOptions) {
    <mat-icon>
      search
    </mat-icon>
    } @else {
    <mat-spinner
      class="search-spinner"
      diameter="21"
      matPrefix
    ></mat-spinner>
    }

  </div>

  <mat-autocomplete
    #rsDynamicMatAutocompleteComponent='matAutocomplete'
    (optionSelected)='optionSelected($event.option.value)'
    [displayWith]='displayWithFunction'
  >
    @for (option of _options; track option) {
    <mat-option [value]='option'>
      {{ displayWithFunction(option) }}
    </mat-option>
    }
  </mat-autocomplete>

  @if (showNoOptionsFoundError) {
  <mat-hint class='warning-hint'>
    {{ 'ERROR_MSG.NO_OPTIONS_FOUND_WITH_THIS_FILTER' | translate }}
  </mat-hint>
  }

  @if (filterFormControl.hasError('required') && required) {
  <mat-error>
    {{ 'ERROR_MSG.REQUIRED_FIELD' | translate }}
  </mat-error>
  }

  @if (filterFormControl.hasError('optionNotSelectedFromMatAutocompleteList')) {
  <mat-error>
    {{ 'ERROR_MSG.PLEASE_SELECT_AN_OPTION' | translate }}
  </mat-error>
  }
</mat-form-field>